export const SUPER_USER_ROLE = 'SUPER_USER';

export const INITIAL_CREATE_FORM = {
  firstName: '',
  lastName: '',
  email: '',
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@.]+$/;
